<template>
  <div class="animated fadeIn">
		<b-row>
      <b-col md="6">
        <b-card>
					<div slot="header">
            <strong><i class="fa fa-align-justify"></i> Modifier actualité</strong>
          </div>
					<b-form-group
              description="Titre dde l'actualité"
              label="Titre"
              label-for="Titre"
            >
            	<b-form-input id="titre" type="text" :class="{hasError: errors.titre !== ''}" v-model="titre"></b-form-input>
              <span class="field-error">{{ errors.titre }}</span>
          </b-form-group>
					<b-form-group
              description="Texte de l'actualité"
              label="Texte"
              label-for="Texte"
            >
            	<b-form-textarea id="texte" type="text" :class="{hasError: errors.texte !== ''}" v-model="texte" style="height:120px"></b-form-textarea>
              <span class="field-error">{{ errors.texte }}</span>
          </b-form-group>
					<div slot="footer">
            <b-button type="button"  @click="cancelForm()" variant="secondary">
								<i class="fa fa-ban"></i> Annuler
						</b-button>
						<b-button type="button"  @click="submitForm()" class="pull-right" size="md" variant="primary">
								<i class="fa fa-save"></i> Enregistrer
						</b-button>
					</div>
        </b-card>
      </b-col>
		</b-row>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '@/utils/auth'

export default {
	data() {
    return {
			titre: '',
			texte: '',
			errors: {
				titre: '',
				texte: ''
			}
		}
	},
	mounted() {
		this.get()
	},
	created() {
    this.$axios.defaults.baseURL = getBaseUrl()
    this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken()
    this.$axios.defaults.headers.common["Accept"] = "application/json"
    this.$axios.defaults.headers.common["Provider"] = getProvider()
	},
	methods: {
		get() {
      this.$store.commit('IS_LOADING', true)
      let id = this.$route.params.id;
      let self = this;
      this.$axios
        .get("/espaceBeneficiaire/newsEb/" + id)
        .then(response => {
					this.$store.commit('IS_LOADING', false)
          this.titre = response.data.newsEb.titre;
          this.texte = response.data.newsEb.texte;
        })
        .catch(function(error) {
          self.$store.commit('IS_LOADING', false)
          self.$swal({ position: 'top', type: 'error', title:'Attention !!', text:'Un problème est survenu, merci de contacter l\'administration',showConfirmButton: false, timer: 5000})
        });
		},
		submitForm() {
      if (this.validateData()) {
        this.$store.commit('IS_LOADING', true);
        let self = this;
        let id = this.$route.params.id;
        let dataPost = {};
        dataPost.titre = this.titre;
        dataPost.texte = this.texte;
        this.$axios
          .put("/espaceBeneficiaire/newsEb/edit/" + id, dataPost)
          .then(response => {
            this.$store.commit('IS_LOADING', false)
            this.$swal({ position: 'top', type: 'success', title:'Modification avec succès', text:"L'actualité a bien été modifiée",showConfirmButton: false, timer: 5000})
            this.$router.push({ path: "/espace-beneficiaire" });
          })
          .catch(function(error) {
            self.$store.commit('IS_LOADING', false)
            self.$swal({ position: 'top', type: 'error', title:'Attention !!', text:'Un problème est survenu, merci de contacter l\'administration',showConfirmButton: false, timer: 5000})
          });
      }
    },
    validateData() {
      this.clearErrors();
      let valid = true;

      if (this.titre.length > 50) {
        valid = false
        this.errors.titre  = 'Veuillez entrer un titre moins long'
      }

      return valid;
    },
    clearErrors() {
      this.errors.titre = "";
      this.errors.texte = "";
    },
    cancelForm() {
      this.$router.push({ path: "/espace-beneficiaire/accueil" });
    }
	}
}
</script>

<style>

</style>
